import { render } from "./DecorationApprovalCard.vue?vue&type=template&id=06c54197&scoped=true"
import script from "./DecorationApprovalCard.vue?vue&type=script&lang=js"
export * from "./DecorationApprovalCard.vue?vue&type=script&lang=js"

import "./DecorationApprovalCard.vue?vue&type=style&index=0&id=06c54197&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c54197"]])

export default __exports__